<template>
  <div>
    <div class="search-wrapper">
      <div class="search">
        <span>所属银行：</span>
        <Input v-model="search.bank" type="text" style="width:100px;margin-right:5px;"></Input>
      </div>
      <div class="search">
        <span>对方户名：</span>
        <Input v-model="search.companyName" style="width:150px;margin-right:5px;"></Input>
      </div>
      <div class="search">
        <span>对方账号：</span>
        <Input v-model="search.companyAccount" style="width:150px;margin-right:5px;"></Input>
      </div>
      <div class="search">
        <span>金额：</span>
        <Input v-model="search.amount[0]" style="width:80px;margin-right:5px;"></Input>
        <span> - </span>
        <Input v-model="search.amount[1]" style="width:80px;margin-right:5px;"></Input>
      </div>
      <div class="search">
        <span>交易日期：</span>
        <DatePicker v-model="search.dealDate" type="daterange" placement="bottom-end" style="width: 200px;margin-right:5px"></DatePicker>
      </div>
      <div class="search">
        <span>领取时间：</span>
        <DatePicker v-model="search.receiveDate" type="daterange" placement="bottom-end" style="width: 200px;margin-right:5px"></DatePicker>
      </div>
      <div class="search">
        <span>状态：</span>
        <Select v-model="search.state" style="width:100px;margin-right:5px;">
          <Option value="0" label="待领取"></Option>
          <Option value="1" label="已领取"></Option>
          <Option value="2" label="已锁定"></Option>
          <Option :value="''" label="全部"></Option>
        </Select>
      </div>
      <Button type="primary" @click="searchDeposit" style="margin-right:5px;">搜索</Button>
      <Button type="success" @click="refreshDeposit" style="margin-right:5px;">广发明细更新</Button>
      <Button type="success" @click="templateImportVisible=true" style="margin-right:5px;">导入明细(银行模板)</Button>
      <Button type="success" @click="importTypeVisible=true" style="margin-right:5px;">导入明细</Button>
      <Button type="success" @click="receiveDetailReport">领取明细</Button>
      <!-- <span style="color:#ed4014;padding:0 20px;font-weight:600;">请注意：状态是给予财务查询的，领取保证金只需领取一条且领取详情只确认一条，请不要重复领取多条！</span> -->
    </div>
    <Table :columns="columns" :data="depositDetails" style="min-width:1200px;"></Table>
    <Page :total="total" show-elevator show-total @on-change="pageChange"></Page>
    <!-- 报名选择 -->
    <Modal v-model="enrollChooseVisible" title="保证金领取" width="700" :mask-closable="false">
      <enroll-choose :depositData="selectDeposit" @receiveSuccess="receiveSuccess"></enroll-choose>
      <div slot="footer">
        <Button @click="enrollChooseVisible=false">取消</Button>
      </div>
    </Modal>
    <!-- 领取详情 -->
    <Modal v-model="receiveDetailVisible" title="领取详情" width="800" :mask-closable="false">
      <!-- <span style="color:#ed4014;margin:5px;">请再次确认保证金领取情况，确认无误后请点确认，否则请删除重新认领！（确认一条数据即可，不要重复确认，重复请删除）</span> -->
      <Table style="margin-top:8px;" :columns="receiveDetailColumns" :data="receiveDetailOrders"></Table>
      <div slot="footer">
        <Button @click="receiveDetailVisible=false">取消</Button>
      </div>
    </Modal>
    <Modal v-model="templateImportVisible" title="模板导入" footer-hide>
      <div style="padding-left: 16px; font-size: 14px; line-height: 28px">
      <p>第一步：选择银行</p>
        <p style="margin: 0 0 24px 40px">
          <Select v-model="templateImportBank" style="width:200px;margin-right:5px;">
          <Option value="浦发银行" label="浦发银行"></Option>
          <Option value="工商银行" label="工商银行"></Option>
          <Option value="江门广发银行" label="江门广发银行"></Option>
          <Option value="军工广发银行" label="军工广发银行"></Option>
          <Option value="邮政储蓄银行" label="邮政储蓄银行"></Option>
        </Select>
        </p>
        <template v-if="templateImportBank">
          <p>第二步：下载 {{templateImportBank}} 明细数据excel模板</p>
          <p style="margin: 0 0 24px 40px">
            <Button style="position: relative" type="primary">
              下载模板
              <a
                :href="templateImportFileUrl"
                download
                style="display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%"
              ></a>
            </Button>
          </p>
          <p>第三步：按模板录入数据并上传excel文件</p>
          <p style="margin-left: 40px">
            <Upload action="/" :before-upload="templateImport">
              <Button type="primary">excel上传</Button>
            </Upload>
          </p>
        </template>
      </div>
    </Modal>
    <!-- 导入类型 -->
    <Modal v-model="importTypeVisible" title="导入类型">
      <Select v-model="importBankName" style="width:200px;margin-right:5px;">
        <Option value="广发银行">广发银行</Option>
        <Option value="建设银行">建设银行</Option>
        <Option value="工商银行">工商银行</Option>
        <Option value="农业银行">农业银行</Option>
        <Option value="惠州工商银行">惠州工商银行</Option>
        <Option value="茂名工商银行">茂名工商银行</Option>
        <Option value="清远工商银行">清远工商银行</Option>
        <Option value="云浮工商银行">云浮工商银行</Option>
        <Option value="湛江工商银行">湛江工商银行</Option>
        <Option value="阳江工商银行">阳江工商银行</Option>
        <Option value="河源广发银行">河源广发银行</Option>
        <Option value="湛江广发银行">湛江广发银行</Option>
        <Option value="清远广发银行">清远广发银行</Option>
        <Option value="惠州广发银行">惠州广发银行</Option>
        <Option value="茂名广发银行">茂名广发银行</Option>
        <Option value="云浮广发银行">云浮广发银行</Option>
        <Option value="阳江广发银行">阳江广发银行</Option>
        <Option value="揭阳广发银行">揭阳广发银行</Option>
        <Option value="四川广发银行">四川广发银行</Option>
        <Option value="佛山广发银行">佛山广发银行</Option>
        <Option value="珠海广发银行">珠海广发银行</Option>
        <Option value="肇庆广发银行">肇庆广发银行</Option>
        <Option value="汕尾广发银行">汕尾广发银行</Option>
        <Option value="韶关广发银行">韶关广发银行</Option>
        <Option value="江门广发银行">江门广发银行</Option>
        <Option value="深圳交通银行">深圳交通银行</Option>
        <Option value="交通银行">交通银行</Option>
        <Option value="渤海银行">渤海银行</Option>
      </Select>
      <div style="color:#ed3f14;line-height:20px;display:inline-block">请注意选择导入文件银行类型</div>
      <div slot="footer">
        <Upload action="/" :before-upload="handleUpload">
          <Button type="primary">确定</Button>
        </Upload>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { formatDate } from '@/lib/tool'
import enrollChoose from './enrollChoose'
import { isNull } from 'util';

export default {
  name: 'receiveDeposit',
  components: {
    enrollChoose
  },
  computed: {
    confirmPermission () {
      return this.$store.getters['session/hasRoles']('退保证金')
    },
    templateImportFileUrl() {
      let url = ''

      switch (this.templateImportBank) {
        case '浦发银行':
          url='https://choicelink-public.oss-cn-shenzhen.aliyuncs.com/4e35c4c416a1416a884e335b9595abc3.xls'
          break;
        case '工商银行':
          url='https://choicelink-public.oss-cn-shenzhen.aliyuncs.com/08fc77a4463e4348b3e2bb46b7758279.xlsx'
          break;
        case '江门广发银行':
          url='https://choicelink-public.oss-cn-shenzhen.aliyuncs.com/0b72fb4f17ef4c8c8b09ab6722ec50ce.xls'
          break;
        case '军工广发银行':
          url='https://choicelink-public.oss-cn-shenzhen.aliyuncs.com/choicelink-offlineSys%2F8jE1Kn5QiD.xls'
          break;
        case '邮政储蓄银行':
          url='https://choicelink-public.oss-cn-shenzhen.aliyuncs.com/choicelink-offlineSys/4zZhQy8O3M.xls'
          break;
        default:
          break;
      }
      return url
    }
  },
  data() {
    return {
      // confirmPermission: false,
      depositDetails: [],
      columns: [
        {
          title: '所属银行',
          key: 'bank',
          width: 110
        },
        {
          title: '对方户名',
          key: 'ghfAccountName'
        },
        {
          title: '对方账号',
          key: 'ghfAccount'
        },
        {
          title: '金额',
          key: 'amount',
          width: 80
        },
        {
          title: '摘要',
          key: 'digest'
        },
        {
          title: '交易日期',
          key: 'dealTime',
          render: (h, params) => {
            let time = '无'
            if (params.row.dealTime) {
              time = params.row.dealTime.split('T')[0]
            }
            return h('div', time)
          },
          width: 100
        },
        {
          title: '备注',
          key: 'comment'
        },
        {
          title: '领取人',
          key: 'editUser',
          width: 75
        },
        {
          title: '领取时间',
          width: 100,
          render: (h, params) => {
            let time = '无'
            if (params.row.editTime) {
              time = params.row.editTime.split('T')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '状态',
          key: 'state',
          width: 80,
          render: (h, params) => {
            let state = {
              '0': '待领取',
              '1': '已领取',
              '2': '已锁定'
            }
            let stateColor = {
              '0': '#ff9900',
              '1': '#ed4014',
              '2': '#19be6b',
            }
            return h('div', {
              style: {
                color: stateColor[params.row.state]
              }
            }, state[params.row.state])
          }
        },
        {
          title: '操作',
          width: 190,
          render: (h, params) => {
            let disabled = false
            let confirmText = '确认'
            let type = 'success'
            if (params.row.state === 2) {
              disabled = true
              confirmText = '取消'
              type = 'warning'
            }
            let isBlock = 'none'
            if (this.confirmPermission) {
              isBlock = 'inline-block'
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: disabled
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.selectDeposit = params.row
                    this.enrollChooseVisible = true
                  }
                }
              }, '领取'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.receiveDetail(params.row)
                  }
                }
              }, '领取详情'),
              h('Button', {
                props: {
                  type: type,
                  size: 'small'
                },
                style: {
                  display: isBlock
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认',
                      content: '确认锁定/解锁此保证金信息？',
                      onOk: async () => {
                        this.selectDeposit = params.row
                        if (params.row.state === 0) {
                          this.$Message.warning('未领取')
                          return
                        }
                        if (params.row.state === 1) {
                          this.selectDeposit.state = 2
                          this.selectDeposit.confirmUser = this.$store.state.session.user.name
                          this.selectDeposit.confirmTime = formatDate()
                        } else if (params.row.state === 2) {
                          this.selectDeposit.state = 1
                          this.selectDeposit.confirmUser = ''
                          this.searchDeposit.confirmTime = ''
                        }
                        this.$Spin.show()
                        try {
                          let rep = await ajax.post(requestUrls.ClMargin.CreateOrUpdate, {
                            clMargin: this.selectDeposit
                          })
                          this.$Spin.hide()
                          if (rep.data.success) {
                            this.$Message.success('操作成功')
                            // 刷新明细表
                            this.getDepositDetails(this.currentPage, this.search)
                          } else {
                            this.$Message.error('操作失败')
                          }
                        } catch (err) {
                          console.error(err)
                          this.$Spin.hide()
                          this.$Message.error('操作失败')
                        }

                      }
                    })
                  }
                }
              }, confirmText)
            ])
          }
        }
      ],
      search: {
        bank: '',
        companyName: '',
        companyAccount: '',
        amount: ['', ''],
        dealDate: [],
        receiveDate: [],
        state: ''
      },
      total: 0,
      currentPage: 1,
      selectDeposit: {},
      enrollChooseVisible: false,
      receiveDetailVisible: false,
      templateImportVisible: false,
      templateImportBank:'',
      importTypeVisible: false,
      receiveDetailOrders: [],
      receiveDetailColumns: [
        {
          title: '领取单位',
          key: 'ghfCompanyName'
        },
        {
          title: '项目编号',
          key: 'projectFull',
          width: 160
        },
        {
          title: '包组号',
          width: 100,
          render: (h, params) => {
            return h('div', params.row.abpOrdersExp.clGroupDb.groupNo)
          }
        },
        {
          title: '金额',
          key: 'orderAmountTotal',
          width: 80
        },
        // {
        //   title: '包组号',
        //   key: 'groupNumber',
        //   render: (h, params) => {
        //     return h('div', params.row.abpOrdersExp.groupNumber)
        //   }
        // },
        {
          title: '操作',
          width: 140,
          render: (h, params) => {
            let disabled = true
            let confirmText = '已确认'
            if (!params.row.confirm && !isNull(params.row.confirm)) {
              disabled = false
              confirmText = '确认'
            }
            let isBlock = 'inline-block'
            // let isBlock = 'none'
            // if (this.confirmPermission) {
            //   isBlock = 'inline-block'
            // }
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: disabled
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除',
                      content: '确认删除此条领取订单？',
                      onOk: async () => {
                        this.$Spin.show()
                        try {
                          let rep = await ajax.delete(requestUrls.order.Delete, {
                            params: {
                              id: params.row.id
                            }
                          })
                          this.$Spin.hide()
                          if (rep.data.success) {
                            this.$Message.success('删除成功')
                            // 刷新订单
                            this.refreshDetail()
                          } else {
                            this.$Message.error('操作失败')
                          }
                        } catch (err) {
                          console.error(err)
                          this.$Spin.hide()
                          this.$Message.error('操作失败')
                        }
                      }
                    })
                  }
                }
              }, '删除'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: disabled,
                },
                style: {
                  display: isBlock
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认',
                      content: '确认后会添加至财务流数据，且此条领取订单不能删除',
                      onOk: async () => {
                        this.$Spin.show()
                        try {
                          let rep = await ajax.get(requestUrls.order.GetMarginConfirm, {
                            params: {
                              orderId: params.row.id,
                              confirm: this.$store.state.session.user.name
                            }
                          })
                          this.$Spin.hide()
                          if (rep.data.success) {
                            this.$Message.success('确认成功')
                            // 刷新订单
                            this.refreshDetail()
                          } else {
                            this.$Message.error('操作失败')
                          }
                        } catch (err) {
                          console.error(err)
                          this.$Spin.hide()
                          this.$Message.error('操作失败')
                        }
                      }
                    })
                  }
                }
              }, confirmText)
            ])
          }
        }
      ],
      importBankName: '广发银行',
    }
  },
  mounted() {
    this.getDepositDetails(this.currentPage, this.search)
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'receiveDeposit') {
        this.getDepositDetails(this.currentPage, this.search)
      }
    }
  },
  methods: {
    async getDepositDetails(page, { bank, companyName, companyAccount, amount, dealDate, state, receiveDate }) {
      this.currentPage = page

      let bankSear = bank ? ` and bank.contains("${bank}")` : ''
      let companyNameSear = companyName ? ` and ghfAccountName.contains("${companyName}")` : ''
      let companyAccountSear = companyAccount ? ` and ghfAccount.contains("${companyAccount}")` : ''
      let amountLowerSear = (amount[0] || parseInt(amount[0]) === 0) ? ` and amount >= "${amount[0]}"` : ''
      let amountUpperSear = (amount[1] || parseInt(amount[1]) === 0) ? ` and amount <= "${amount[1]}"` : ''
      let stateSear = state ? ` and state=="${state}"` : ''

      let end = ''
      let start = ''
      if (dealDate[0] && dealDate[1]) {
        start = formatDate(dealDate[0]).split(' ')[0]
        end = formatDate(dealDate[1]).split(' ')[0]
      }
      let dealDateSear = (start && end) ? ` and dealTime >= "${start}" and dealTime <= "${end}"` : ''

      let receiveEnd = ''
      let receiveStart = ''
      if (receiveDate[0] && receiveDate[1]) {
        receiveStart = formatDate(receiveDate[0]).split(' ')[0]
        receiveEnd = formatDate(receiveDate[1]).split(' ')[0]
      }
      let receiveDateSear = (receiveEnd && receiveStart) ? ` and editTime >= "${receiveStart}" and editTime <= "${receiveEnd}"` : ''

      let filter = bankSear + companyNameSear + companyAccountSear + companyAccountSear + amountLowerSear + amountUpperSear + dealDateSear + stateSear + receiveDateSear
      filter = filter.slice(5)

      let rep = await ajax.get(requestUrls.ClMargin.getPaged, {
        params: {
          filter: filter,
          sorting: 'id desc',
          maxResultCount: 10,
          skipCount: (page - 1) * 10
        }
      })
      if (rep.data.success) {
        this.depositDetails = rep.data.result.items
        this.total = rep.data.result.totalCount
      }
    },
    pageChange(page) {
      this.getDepositDetails(page, this.search)
    },
    searchDeposit() {
      this.getDepositDetails(1, this.search)
    },
    // 标记
    async receiveSuccess() {
      this.enrollChooseVisible = false
      // // 更新状态
      this.selectDeposit.state = 1
      // // 领取人员
      this.selectDeposit.editUser = this.$store.state.session.user.name
      this.selectDeposit.editTime = formatDate()
      // let rep = await ajax.post(requestUrls.ClMargin.CreateOrUpdate, {
      //   clMargin: this.selectDeposit
      // })
      // 刷新数据
      await this.getDepositDetails(this.currentPage, this.search)
      // 显示确认
      // this.receiveDetailVisible = true
      this.receiveDetail(this.selectDeposit)
    },
    handleUpload(file) {
      // this.file = file
      this.$Modal.confirm({
        title: '数据导入',
        content: `确认导入 ${file.name} 表格数据？`,
        onOk: async () => {
          this.$Spin.show()
          try {
            let formData = new FormData()
            formData.append('file', file)
            formData.append('bankName', this.importBankName)
            let rep = await ajax.post(requestUrls.ClMargin.ExcelImport, formData)
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('导入成功')
              // 刷新数据
              this.getDepositDetails(this.currentPage, this.search)
            } else {
              this.$Message.error('导入失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('导入失败')
          }
        },
        onCancel: () => {
          this.$Message.info('导入取消')
        }
      })
      return false
    },
    // 刷新领取订单
    async refreshDetail() {
      let rep = await ajax.get(requestUrls.order.getPaged, {
        params: {
          filter: `clMarginId=="${this.selectDeposit.id}" and orderType == "保证金"`,
          sorting: 'orderNo',
          maxResultCount: 200,
          skipCount: 0
        }
      })
      this.receiveDetailOrders = rep.data.result.items
      // 全部删除修改状态
      if (rep.data.result.items.length === 0) {
        this.selectDeposit.state = 0
        this.selectDeposit.editUser = ''
        this.selectDeposit.editTime = ''
        await ajax.post(requestUrls.ClMargin.CreateOrUpdate, {
          clMargin: this.selectDeposit
        })
      }
    },
    async receiveDetail(deposit) {
      if (deposit.state === 0) {
        this.$Message.info('尚未领取')
        return
      }
      this.selectDeposit = deposit
      this.$Spin.show()
      try {
        let rep = await ajax.get(requestUrls.order.getPaged, {
          params: {
            filter: `clMarginId=="${this.selectDeposit.id}" and orderType == "保证金"`,
            sorting: 'orderNo',
            maxResultCount: 100,
            skipCount: 0
          }
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.receiveDetailOrders = rep.data.result.items
          this.receiveDetailVisible = true
        } else {
          this.$Message.error('获取详情失败')
        }
      } catch (err) {
        this.$Spin.hide()
        this.$Message.error('获取详情失败')
        console.error(err)
      }
    },
    receiveDetailReport() {
      window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B4fdd%5D%5B8bc1%5D%5B91d1%5D%2FBond.cpt`)
    },
    async refreshDeposit() {
      this.$Spin.show()
      let rep = await ajax.post(requestUrls.ClMargin.RefreshMargin)
      this.$Spin.hide()
    },
    templateImport(file) {
      if(!this.templateImportBank) return
      this.$Modal.confirm({
        title: '数据导入',
        content: `确认导入 ${file.name} 表格数据？`,
        onOk: async () => {
          this.$Spin.show()
          try {
            let formData = new FormData()
            formData.append('file', file)
            formData.append('bankName', this.templateImportBank)
            let rep = await ajax.post('https://www.choicelink.cn:8444/cailian/margin/excelImport', formData)
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('导入成功')
              // 刷新数据
              this.getDepositDetails(this.currentPage, this.search)
            } else {
              this.$Message.error('导入失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('导入失败')
          }
        },
        onCancel: () => {
          this.$Message.info('导入取消')
        }
      })
      return false
    },
  }
}
</script>

<style lang="less" scoped>
.search-wrapper {
  margin: 0 0 5px 0;
  .search {
    display: inline-block;
    margin: 0 5px 5px 0;
  }
}
</style>
